import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "aos/dist/aos.css";
import AOS from "aos";
import "animate.css";


const HomeLoanTaxBenefits = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const hero = document.querySelector(".tax-hero");
      if (hero) hero.style.backgroundPositionY = scrolled * 0.5 + "px";
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      <section className="tax-hero d-flex align-items-center justify-content-center text-white text-center" style={{ background: "linear-gradient(135deg, #62cff4, #2c67f2)", minHeight: "60vh", overflow: "hidden" }}>
        <div className="container">
          <h1 className="display-3 fw-bold mb-4 animate__animated animate__fadeInDown">
            <i className="bi bi-cash-coin floating"></i>
            <br />Home Loan Tax Benefits
          </h1>
          <p className="lead">Maximize Your Savings with Smart Tax Planning</p>
        </div>
      </section>

      <div className="container py-5">
        {/* Key Benefits Section */}
        <div className="row g-4 mb-5" data-aos="fade-up">
          {[
            { title: "Section 80C", desc: "Deduction on principal amount", amount: "Rs. 1.5 Lakh" },
            { title: "Section 24(b)", desc: "Deduction on the interest amount", amount: "Rs. 2 Lakh" },
            { title: "Section 80EE", desc: "Deduction for first time buyers", amount: "Rs. 50,000" }
          ].map((item, idx) => (
            <div className="col-md-4" key={idx}>
              <div className="benefit-card p-4 h-100 bg-white rounded-4 shadow-sm">
                <h3 className="text-primary"><i className="bi bi-percent"></i> {item.title}</h3>
                <p className="text-muted">{item.desc}</p>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">{item.amount}</li>
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Tax Exemption Table */}
        <div className="tax-table shadow-lg mb-5" data-aos="zoom-in">
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-primary">
                <tr>
                  <th>Section</th>
                  <th>Deduction</th>
                  <th>Conditions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>80C</td>
                  <td>₹1.5 Lakh</td>
                  <td>Deduction for repayment of home loan principal, including stamp duty & registration fees (once, same year).</td>
                </tr>
                <tr>
                  <td>Section 24(b)</td>
                  <td>Rs. 2 Lakh</td>
                  <td>Tax deduction on home loan interest paid for self-occupied/vacant residential properties.</td>
                </tr>
                <tr>
                  <td>Section 80EE</td>
                  <td>Rs. 50,000</td>
                  <td>First-time homebuyers with housing loans sanctioned before April 2022.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Eligibility Section */}
        <div className="row g-4 mb-5" data-aos="fade-right">
          <div className="col-md-4">
            <div className="benefit-card p-4 h-100 bg-white rounded-4 shadow-sm">
              <h4><i className="bi bi-file-earmark-check"></i> Eligibility</h4>
              <ul className="list-group list-group-flush">
                <li className="list-group-item">Residents & NRIs</li>
                <li className="list-group-item">Individual applicants</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Criteria Table */}
        <div className="tax-table shadow-lg mb-5" data-aos="zoom-in">
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-primary">
                <tr>
                  <th>Section</th>
                  <th>Criteria</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Section 24(b)</td>
                  <td>Home Loans should be taken before 31 March 2025</td>
                </tr>
                <tr>
                  <td>Section 80C</td>
                  <td>Property not sold within 5 years of completion</td>
                </tr>
                <tr>
                  <td>Section 80EE</td>
                  <td>Loan amount should be Rs. 35 Lakh or less</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Special Categories */}
        <div className="row g-4">
          <div className="col-md-6" data-aos="fade-right">
            <div className="benefit-card p-4 h-100 bg-white rounded-4 shadow-sm">
              <h3 className="text-primary"><i className="bi bi-gender-female"></i> Women Homebuyers</h3>
              <ul className="list-group list-group-flush">
                <li className="list-group-item">₹1.5L principal deduction</li>
                <li className="list-group-item">Co-owner benefits</li>
                <li className="list-group-item">Women with joint loans eligible for separate deductions</li>
                <li className="list-group-item">Co-owners can claim on principal & interest</li>
                <li className="list-group-item">First-time buyer: Extra ₹50,000 under 80EE</li>
              </ul>
            </div>
          </div>

          <div className="col-md-6" data-aos="fade-left">
            <div className="benefit-card p-4 h-100 bg-white rounded-4 shadow-sm">
              <h3 className="text-primary"><i className="bi bi-person-hearts"></i> Senior Citizens</h3>
              <ul className="list-group list-group-flush">
                <li className="list-group-item">Age 60-80 years</li>
                <li className="list-group-item">Special deductions</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeLoanTaxBenefits;
